// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }


  const productQtyInputs = () =>
    document.querySelectorAll(".productView-quantity .quantity__input");

  // A Yampi desabilita os botoes [name="add"] enquanto consulta o status da loja
  // e o quantity-input do tema copia esse estado (variants.js/checkVariantInventory).
  // Como a Yampi so reabilita o botao, a quantidade continuava disabled: campos
  // disabled nao entram no serialize do form, entao o /cart/add.js ia sem
  // "quantity" e o carrinho sempre recebia 1 item.
  const syncQuantityAvailability = () => {
    const addButton = document.getElementById("product-add-to-cart");
    if (!addButton) return;

    productQtyInputs().forEach((input) => {
      input.disabled = addButton.disabled;
      input
        .closest("quantity-input")
        ?.querySelectorAll(".btn-quantity")
        .forEach((button) => {
          button.disabled = addButton.disabled;
        });
    });
  };

  const addToCartButton = document.getElementById("product-add-to-cart");
  if (addToCartButton) {
    syncQuantityAvailability();
    new MutationObserver(syncQuantityAvailability).observe(addToCartButton, {
      attributes: true,
      attributeFilter: ["disabled"],
    });
  }

  const progressiveOfferRadios = document.querySelectorAll(
    'input[name="progressive-offer"]'
  );
  progressiveOfferRadios.forEach((radio) => {
    radio.addEventListener("change", function (e) {
      if (radio.checked) {
        // Replica em todos os seletores de quantidade (principal, oculto e sticky)
        productQtyInputs().forEach((input) => {
          input.value = radio.value;
        });

        const mainQtInput = document.querySelector(
          ".quantity__group--1 .quantity__input"
        );
        // Avisa o tema para recalcular subtotal, preco sticky e regras de estoque
        mainQtInput?.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
});

/**
 * Abertura otimista do carrinho lateral.
 *
 * O tema so abre o drawer depois de TRES requisicoes em serie:
 *   1. POST /cart/add.js            ~584ms
 *   2. GET  /cart.js                ~250ms  (dentro do callback da 1)
 *   3. GET  /cart?view=ajax_side_cart ~322ms, 80KB (dentro do callback da 2)
 * Medido em desktop com conexao boa: ~1,15s ate o drawer aparecer. No 4G a
 * latencia triplica e passa de 3s com um spinner girando na tela.
 *
 * Aqui o drawer abre no clique, com skeleton no lugar do conteudo. As tres
 * requisicoes seguem iguais, mas por tras: quando a etapa 3 responde, o tema
 * faz .html(response) no .previewCart-wrapper e o skeleton e substituido pelo
 * conteudo real sem piscar.
 *
 * Nao altera o fluxo do tema nem o modal de upsell — so antecipa a abertura.
 */
(function () {
  var WRAPPER = "#halo-cart-sidebar .previewCart-wrapper";
  var CLASSE_ABERTO = "cart-sidebar-show";
  var CLASSE_SKELETON = "previewCart--skeleton";
  var LIMITE_MS = 2500; // apos isso, busca o conteudo por conta propria

  var timeoutSeguranca = null;
  var desfazer = null; // preenchido enquanto ha uma abertura otimista no ar

  function drawerConfigurado() {
    // Se a loja estiver configurada para redirecionar ao carrinho ou nao usar
    // o quick cart, abrir o drawer seria errado.
    return (
      window.quick_cart &&
      window.quick_cart.show &&
      window.after_add_to_cart &&
      window.after_add_to_cart.type === "quick_cart"
    );
  }

  function montarSkeleton(linhas) {
    var item =
      '<div class="previewCartSkeleton__item">' +
      '<div class="previewCartSkeleton__thumb"></div>' +
      '<div class="previewCartSkeleton__lines">' +
      '<span class="previewCartSkeleton__line previewCartSkeleton__line--lg"></span>' +
      '<span class="previewCartSkeleton__line previewCartSkeleton__line--sm"></span>' +
      "</div></div>";
    return (
      '<div class="previewCartSkeleton" aria-hidden="true">' +
      new Array(linhas + 1).join(item) +
      '<div class="previewCartSkeleton__footer">' +
      '<span class="previewCartSkeleton__line previewCartSkeleton__line--md"></span>' +
      '<div class="previewCartSkeleton__cta"></div>' +
      "</div></div>"
    );
  }

  function limpar() {
    clearTimeout(timeoutSeguranca);
    var wrapper = document.querySelector(WRAPPER);
    if (wrapper) wrapper.classList.remove(CLASSE_SKELETON);
  }

  function abrirComSkeleton() {
    if (!drawerConfigurado()) return;

    var wrapper = document.querySelector(WRAPPER);
    if (!wrapper) return;

    // Carrinho ja aberto e populado: nao mexe.
    if (document.body.classList.contains(CLASSE_ABERTO) && wrapper.children.length) return;

    // Quantas linhas de skeleton: o que ja esta no carrinho + o item entrando.
    var atual = document.querySelector(".cart-count-bubble [data-cart-count]");
    var n = atual ? parseInt((atual.textContent || "").replace(/\D/g, ""), 10) : 0;
    if (isNaN(n)) n = 0;
    wrapper.innerHTML = montarSkeleton(Math.min(n + 1, 3));
    wrapper.classList.add(CLASSE_SKELETON);

    document.body.classList.add(CLASSE_ABERTO);

    // O tema substitui o conteudo do wrapper quando a etapa 3 responde.
    var obs = new MutationObserver(function () {
      if (!wrapper.querySelector(".previewCartSkeleton")) {
        obs.disconnect();
        desfazer = null;
        limpar();
      }
    });
    obs.observe(wrapper, { childList: true });

    /**
     * Fecha a abertura otimista. So faz sentido quando o carrinho continua
     * vazio: se o produto entrou, fechar esconderia justamente o que a cliente
     * quer ver — nesse caso o fallback abaixo busca o conteudo por conta.
     */
    desfazer = function () {
      desfazer = null;
      obs.disconnect();
      clearTimeout(timeoutSeguranca);
      if (wrapper.querySelector(".previewCartSkeleton")) {
        wrapper.innerHTML = "";
        wrapper.classList.remove(CLASSE_SKELETON);
        document.body.classList.remove(CLASSE_ABERTO);
      }
    };

    /**
     * Rede de seguranca: se o skeleton ainda estiver no ar depois do limite, o
     * tema nao preencheu. Antes de desistir, verifica o carrinho de verdade —
     * produto dentro significa que so faltou o HTML, entao busca o mesmo
     * endpoint que o tema usaria. So fecha se o carrinho estiver realmente
     * vazio (add recusado).
     */
    clearTimeout(timeoutSeguranca);
    timeoutSeguranca = setTimeout(function () {
      if (!wrapper.querySelector(".previewCartSkeleton")) return;

      fetch(window.Shopify.routes.root + "cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (carrinho) {
          if (!carrinho || !carrinho.item_count) throw new Error("carrinho vazio");
          return fetch(window.Shopify.routes.root + "cart?view=ajax_side_cart", {
            credentials: "same-origin",
          }).then(function (r) { return r.text(); });
        })
        .then(function (html) {
          if (!wrapper.querySelector(".previewCartSkeleton")) return; // tema chegou antes
          obs.disconnect();
          desfazer = null;
          wrapper.innerHTML = html;
          wrapper.classList.remove(CLASSE_SKELETON);
        })
        .catch(function () {
          if (desfazer) desfazer();
        });
    }, LIMITE_MS);
  }

  function aoClicar(event) {
    var alvo = event.target.closest(
      '#product-add-to-cart, .product-form__submit, [data-action-add-to-cart], .previewCartCollection a.button-ATC'
    );
    if (!alvo) return;
    if (alvo.disabled || alvo.getAttribute("aria-disabled") === "true") return;
    // "Esgotado"/"Avise-me" nao adicionam nada ao carrinho.
    if (alvo.classList.contains("is-notify-me")) return;
    abrirComSkeleton();
  }

  /**
   * Capture, mas registrado DEPOIS do popup de upsell — e a ordem e o que faz
   * o carrinho abrir na hora certa.
   *
   * O upsell (snippet upsell-imunofem-popup) tambem escuta clique em capture no
   * document e, quando a variante casa com a oferta, chama
   * stopImmediatePropagation() para segurar o add e mostrar a oferta primeiro.
   * Depois que a cliente aceita ou recusa, ele re-dispara o mesmo clique com
   * bypass, e ai o add acontece de verdade.
   *
   * Listeners de capture no mesmo elemento rodam na ordem de registro. Como o
   * custom.js e carregado antes do snippet no theme.liquid, este handler rodava
   * primeiro e abria o drawer no clique interceptado — o carrinho aparecia atras
   * do popup e ficava la, escondido, ate a cliente responder a oferta.
   *
   * Adiando o registro para depois do parse, o popup entra na fila primeiro:
   * no clique interceptado o stopImmediatePropagation nos bloqueia, e no
   * re-clique com bypass o drawer abre normalmente. Resultado: um painel de
   * cada vez, sem replicar aqui nenhuma regra de qual variante tem oferta.
   */
  function registrar() {
    document.addEventListener("click", aoClicar, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", registrar);
  } else {
    registrar();
  }
})();
